<script setup lang="ts">
import { User, UserAction, UserStep } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
});

const store = useStore<ShiftCMSState & { us: UsersState }>();

const actions = computed<UserAction[]>(() => store.state.us.userActions);
const steps = computed<UserStep[]>(() => store.state.us.userSteps);

const headers = [
  { title: 'Action', key: 'action.title' },
  { title: 'Status', key: 'completed' },
  { title: 'Completed Steps', key: 'steps' },
  { title: 'Options', key: 'options' },
];

function deleteUserAction(id: number) {
  store.dispatch(UsersActions.DeleteUserAction, {
    id,
    userId: props.user.id,
    stepIds: props.user.steps.map((s) => s.id),
  });
}
</script>
<template>
  <v-card class="mt-4">
    <v-card-title>Actions</v-card-title>

    <v-data-table
      density="compact"
      :headers="headers"
      :items="actions"
      itemsPerPage="10"
      hover
    >
      <template v-slot:item.completed="{ value }">
        {{ value ? 'Completed' : 'Open' }}
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn
          density="compact"
          icon="mdi-delete-outline"
          @click="deleteUserAction(item.id)"
        />
      </template>
      <template v-slot:item.steps="{ item }">
        {{
          steps.filter((us) =>
            item.action.steps.map((s) => s.id).includes(us.step.id),
          ).length
        }}
        / {{ item.action.steps.length }}</template
      >
    </v-data-table>
  </v-card>
</template>
